import {
  PlaycastMessage,
  PlaycastMessageOverlayCreateImageOverlay,
  PlaycastMessageOverlayDeleteOverlay,
  PlaycastMessageSource,
} from '../types';
import { formatMessage } from './_util/formatMessage';

const target = 'overlayManager';

export const overlayCreateImageOverlay = (
  hostId: string,
  overlayName: string,
  destName: string,
  imagePath: string,
  translate: number[],
  rotate: number[],
  scale: number[],
  visible: boolean,
  userAuth?: string,
): PlaycastMessage<PlaycastMessageOverlayCreateImageOverlay> => {
  const messageSource: PlaycastMessageSource = 'host';
  const message: PlaycastMessageOverlayCreateImageOverlay = {
    target,
    action: 'createImageOverlay',
    isReply: false,
    message: {
      overlayName,
      destName,
      overlayDetails: {
        imagePath,
        transform: {
          translate,
          rotate,
          scale,
        },
        visible,
      },
    },
  };
  return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageOverlayCreateImageOverlay>;
};

export const overlayDeleteOverlay = (
  hostId: string,
  overlayName: string,
  userAuth?: string,
): PlaycastMessage<PlaycastMessageOverlayDeleteOverlay> => {
  const messageSource: PlaycastMessageSource = 'host';
  const message: PlaycastMessageOverlayDeleteOverlay = {
    target,
    action: 'deleteOverlay',
    isReply: false,
    message: {
      overlayName,
    },
  };
  return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageOverlayDeleteOverlay>;
};
